import React from 'react';
import EventEmitter from '../utils/emmiter';
import {UserContext} from '../utils/usercontext';
import {useracc} from '../utils/functions';

export default class Loading extends React.Component {
	static contextType = UserContext;
  constructor(props) {
		super(props);
	}

	async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
	}

	render() {
		return (
			<></>
		)
	}
}
